import { Button } from '@factorialco/deprecated-design-system'
import {
  CustomCategoriesPageDocument,
  FinanceCustomSubcategoryItemFragment,
  SoftDeleteFinanceCustomCategoryDocument,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  category: FinanceCustomSubcategoryItemFragment
  onClose: () => void
}

const DeleteCustomCategoryModal = ({ category, onClose }: Props) => {
  const { company } = useCurrentSession()

  const [softDeleteCategory] = useMutation(SoftDeleteFinanceCustomCategoryDocument, {
    extractorFn: (data) => data.financeMutations.softDeleteFinanceCustomCategory,
  })

  const onDeleteCategory = async () => {
    const result = await softDeleteCategory({
      variables: {
        id: category.id,
        companyId: company.id,
      },
      refetchQueries: [CustomCategoriesPageDocument],
    }).then((res) => {
      track(trackingEvents.accounting.settings.categories.deleteSubcategory)
      return res
    })

    const handled = handleResult(result, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('errors.generic_error'),
      })
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.saved_successfully'),
      })

      handleClose()
    }

    return handled
  }

  const handleClose = () => {
    onClose()
  }

  return (
    <Modal
      illustration="alert"
      title={i18n.t('finance.settings.accounting.custom_categories.modals.delete.title')}
      description={i18n.t(
        'finance.settings.accounting.custom_categories.modals.delete.description',
        { name: category.label }
      )}
      footer={
        <>
          <Button type="secondary" onClick={handleClose}>
            {i18n.t('finance.settings.accounting.custom_categories.modals.buttons.cancel')}
          </Button>
          <Button onClick={onDeleteCategory}>
            {i18n.t('finance.settings.accounting.custom_categories.modals.buttons.ok')}
          </Button>
        </>
      }
      onClose={onClose}
    />
  )
}

export default DeleteCustomCategoryModal
